export var TableTypes;
(function (TableTypes) {
    TableTypes["TABLE"] = "TABLE";
    TableTypes["TABLE_SELECTABLE"] = "TABLE_SELECTABLE";
    TableTypes["TABLE_EXPANDABLE"] = "TABLE_EXPANDABLE";
})(TableTypes || (TableTypes = {}));
export var HeaderSortOptions;
(function (HeaderSortOptions) {
    HeaderSortOptions["BLOCK_OF_TEXT"] = "BLOCK_OF_TEXT";
    HeaderSortOptions["CURRENCY"] = "CURRENCY";
    HeaderSortOptions["DATE"] = "DATE";
    HeaderSortOptions["DATETIME"] = "DATETIME";
    HeaderSortOptions["NUMBER"] = "NUMBER";
    HeaderSortOptions["PERCENT"] = "PERCENT";
    HeaderSortOptions["TEXT"] = "TEXT";
})(HeaderSortOptions || (HeaderSortOptions = {}));
export const CENTRAL_TIME_ZONE = 'America/Chicago';
